import { Input, Modal, message } from 'antd';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { type InviteCode, inviteCodeStore } from '@/stores';

interface SendInviteCodeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  inviteCode: InviteCode | null;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function SendInviteCodeDialog({
  open,
  onOpenChange,
  inviteCode,
}: SendInviteCodeDialogProps) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    onOpenChange(false);
    setEmail('');
  };

  const handleSubmit = async () => {
    if (loading || !inviteCode) return;
    const trimmed = email.trim();
    if (!EMAIL_RE.test(trimmed)) {
      message.error('请输入有效的邮箱地址');
      return;
    }
    setLoading(true);
    try {
      await inviteCodeStore.sendInviteCode(inviteCode.id, trimmed);
      message.success('邀请码已发送');
      handleClose();
    } catch (error) {
      console.error('发送邀请码失败:', error);
      message.error('发送失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title="发送邀请码"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={handleClose}>
            取消
          </Button>
          <Button onClick={handleSubmit} disabled={loading}>
            {loading ? '发送中...' : '发送'}
          </Button>
        </div>
      }
      centered
    >
      <div className="space-y-4 py-2">
        <p className="text-sm text-muted-foreground">
          邀请码：
          <span className="font-mono font-medium">{inviteCode?.code}</span>
        </p>
        <div className="space-y-2">
          <Label htmlFor="send-email">收件邮箱</Label>
          <Input
            id="send-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="user@example.com"
            onPressEnter={handleSubmit}
          />
        </div>
      </div>
    </Modal>
  );
}
